export default {
    '您的银行户口尚未开通。': 'Your Savings Account is not opened yet.',
    '您的银行户口审核中。': 'Your bank account is under review.',
    '当前户口销户中，请耐心等待': 'In the current account cancellation, please be patient',
    '受金管局监管要求，您需通过本人户口存入500以上金额的港币方能使用本户口': 'Under the supervision of the HKMA, you need to deposit more than 500 HKD in your account to use this account',
    '系统繁忙, 请稍后再试': 'System busy, please try again later.',
    我知道了: 'OK',
    立即开通: 'Open Now',
    立即激活: 'Activate Now',
    温馨提示: 'Reminder',
    '错误码：': 'Error code: ',
};
